import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/services/51224083.jpg'


const _hoisted_1 = { class: "flexX_center" }
const _hoisted_2 = {
  class: "services flexY_start",
  style: {"margin-bottom":"200px"}
}
const _hoisted_3 = { class: "flexX_SB" }

import AddPositioning from "./component/AddPositioning.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "flexY_center",
        style: {"margin":"60px 0"}
      }, [
        _createElementVNode("div", { style: {"font-size":"60px","color":"#ebebf3","font-weight":"700"} }, " CONTECT US "),
        _createElementVNode("div", { style: {"font-size":"40px","color":"#000000","font-weight":"600","margin-top":"-40px"} }, " 联系我们 "),
        _createElementVNode("div", { style: {"background-color":"rgb(19, 100, 233)","height":"7px","width":"80px","margin-top":"30px"} })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_0,
          style: {"margin-right":"20px"}
        }, null, -1)),
        _createVNode(AddPositioning)
      ])
    ])
  ]))
}
}

})